/*eslint no-undef: */
// import Vue from 'vue'
// import Vuex from 'vuex'

Vue.use(Vuex)

function addMessage (message) {
  let sessionLogs = sessionStorage.getItem('LOGS');
  if (!sessionLogs) sessionLogs = [];
  else sessionLogs = JSON.parse(sessionLogs);
  sessionLogs.push(message);
  if (sessionLogs.length > 10) sessionLogs.splice(0, 1);
  sessionStorage.setItem('LOGS', JSON.stringify(sessionLogs));
  return sessionLogs.length;
}

export default new Vuex.Store({
  state: {
    loadingNum: 0,
    messageDialog: {}, // value,type,title,content,icon,color,okFn,cancelFn
    logNum: 0,

    token: null,
    avatar: '',
    username: '',
    userpoint: 0,
  },
  mutations: {
    showLoading: (state) => ++state.loadingNum,
    hideLoading: (state) => state.loadingNum = 0,
    showMessageDialog: (state, value) => {
      state.messageDialog = { value: true, ...value };
      if (value.type == 'error' && state.token) {
        let logNum = addMessage(value);
        state.logNum = logNum;
      }
    },

    setToken: (state, value) => state.token = value,
    setAvatar: (state, value) => state.avatar = value,
    setUsername: (state, value) => state.username = value,
    setUserpoint: (state, value) => state.userpoint = value,
  },
  // actions: {
  //   setLoading ({ commit }, flag) { commit('setLoading', flag) },
  //   hideLoading ({ commit }) { commit('hideLoading') },
  //   setToken ({ commit }, value) { commit('setToken', value) }
  // },
  getters: {
    token (state) { return state.token }
  }
})
